<template>
  <router-link v-if="value" :to="{name: 'newsDetail', params: {id: value.id}}">
    <v-card class="mb-8 px-6 mr-2">
      <v-row>
        <v-col class="d-flex d-inline-flex" cols="12">
          <div v-style:paddingLeft="$valueByBreakpoint({xs: '20px', sm: '0'})"
               v-style:width="value.teaserThumbnailUrl  && !hideThumbnail ? $valueByBreakpoint({xs: '83vw', sm: '53vw', md: '33vw', lg: '33vw', xl: '33vw'}) : '100%'"
               style="background-color: white; z-index: 15; padding: 24px 25px 0 0;">
            <fin-news-item-source-date-category :value="value"/>
            <p class="featured-article__title" style="width: 100%">{{ value.title }}</p>
            <!-- false because teaserText contains the same as title -->
            <p v-if="false" class="featured-article__teaser" style="width: 100%">{{ value.teaserText }}</p>
            <div class="featured-article__teaser" v-html="value.content"/>
          </div>
          <div v-if="value.teaserThumbnailUrl && !hideThumbnail"
               v-style:maxHeight="$valueByBreakpoint({xs: '320px', sm: '300px', md: '300px', lg: '300px'})"
               v-style:width="$valueByBreakpoint({xs: '140vw', sm: '68vw', md: '63vw', lg: '63vw'})"
               class="featured-article__image d-flex"
               style="position: absolute; bottom: 0">
            <v-img :src="value.teaserThumbnailUrl" eager>
              <v-container slot="placeholder" fill-height fluid ma-0>
                <v-row align="center" justify="center">
                  <fin-logo-full dark loading></fin-logo-full>
                </v-row>
              </v-container>
            </v-img>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </router-link>
</template>


<script>
import finLogoFull from '@/components/common/logo/LogoFull/index'
import FinNewsItemSourceDateCategory from './NewsItemSourceDateCategory'

export default {
  name: 'fin-featured-news-item',
  components: {FinNewsItemSourceDateCategory, finLogoFull},
  data() {
    return {
      hideThumbnail: process.env.VUE_APP_HIDE_NEWS_THUMBNAILS === 'true'
    }
  },
  props: {
    value: {
      type: Object
    }
  }
}
</script>


<style lang="scss" scoped>

.featured-article__title {
  font-size: 28px;
  font-family: heading-font-family;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 33px;
  letter-spacing: normal;

  @media only screen and (max-width: 960px) {
    font-size: 24px;
  }
}

.featured-article__image {
  position: absolute;
  right: 0;
  z-index: 0;
  max-height: 383px; // TODO: calculate
  overflow: hidden;
}

.featured-article__category {
  font-size: 0.9em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  background-color: $fin-color-pale-grey;
  border: solid 1px $fin-color-light-blue-gray;
  border-radius: 0;
  padding: 2px 8px;
}

::v-deep .v-chip__content {
  height: auto !important;
}

::v-deep .v-chip.v-size--default {
  height: auto !important;
}

.featured-article__source-date {
  font-size: 0.9em;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  color: $fin-color-cool-grey;
  display: inline-block;
}

::v-deep .featured-article__teaser {
  font-size: 1em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  max-height: 30px;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

  }
}


</style>
